// import "mutationobserver-shim"
import "./main.scss"
import "vue-sonner/style.css"
import { createApp } from "vue"
import BasePage from "./components/Common/BasePage/BasePage.vue"
// import BuisyIndicator from "./components/Common/BuisyIndicator.vue"
// import BuisyIndicatorPlugin from "@/plugins/BuisyIndicator"
// import ChristmasTreeStore from "@/stores/christmasTreeStore"
import DonatePage from "./views/Donate/Donate.vue"
// import GlobalConfig from "./components/Common/GlobalConfig.vue"
import HospiceList from "@/views/Hospice/HospiceList/HospiceList.vue"
import Hospice from "@/views/Hospice/Hospice.vue"
import NavigationBar from "./components/NavigationBar/NavigationBar.vue"
// import OrderConfirmation from "./components/OrderConfirmation/OrderConfirmation.vue"
import PersonalizedDonatePage from "@/views/Donate/DonatePersonalized.vue"
// import SiteAlert from "@/components/Common/SiteAlert.vue"
import TreeRegistration from "@/views/TreeRegistration/TreeRegistration.vue"
// import { VueTelInput } from "vue-tel-input"
// import Vuelidate from "vuelidate"
import axios from "axios"
// import linkify from "vue-linkify"
// import vueScrollTo from "vue-scrollto"
import VolunteerRegistrationView from "./views/VolunteerRegistration/VolunteerRegistration.vue"
import { VueQueryPlugin } from "@tanstack/vue-query"
import FooterBar from "./components/FooterBar/FooterBar.vue"
import ContactView from "./views/Contact/Contact.vue"
import { createPinia } from "pinia"
import Faq from "./views/Faq/Faq.vue"
import ErrorPage from "./views/ErrorPage/ErrorPage.vue"
import Articles from "./views/Article/ArticleList.vue"
import Article from "./views/Article/Article/Article.vue"
import Home from "./views/Home/Home.vue"
import { Button } from "./components/ui/button"
import OrderConfirmation from "./views/OrderConfirmation/OrderConfirmation.vue"
import OrderReview from "./views/OrderReview/OrderReview.vue"
import OrderCancel from "./views/OrderCancel/OrderCancel.vue"
//import RegisterTree from './components/DataCollection/RegisterTree/RegisterTree';
import "viewerjs/dist/viewer.css"
import VueViewer from "v-viewer"
const pinia = createPinia()
const app = createApp({})
// app.use(vueScrollTo)
// app.use(BuisyIndicatorPlugin, { className: "buisy" })
// app.use(Vuelidate)
// app.use(VueGoogleMaps)
// app.use(VueTelInput, {
//   defaultCountry: "GB",
//   disabledFetchingCountry: true,
//   validCharactersOnly: true,
//   wrapperClasses: "custom-select custom-phone",
//   preferredCountries: ["GB"],
//   mode: "international",
// })
// app.directive("linkified", linkify)

axios.interceptors.request.use((config) => {
  const url = config.url?.replace(/^\//, "")

  if (url?.startsWith("umbraco/api/") && window.__STATE__) {
    const { culture, currentPageId } = window.__STATE__
    config.headers["X-Umb-Culture"] = culture
    config.headers["X-Umb-PageId"] = currentPageId
  }

  return config
}, Promise.reject)

app.component("ArticlesPage", Articles)
app.component("ArticlePage", Article)
app.component("BasePage", BasePage)
// app.component("BuisyIndicator", BuisyIndicator)
app.component("FaqPage", Faq)
app.component("DonatePage", DonatePage)
app.component("PersonalizedDonatePage", PersonalizedDonatePage)
app.component("ErrorPage", ErrorPage)
// app.component("GlobalConfig", GlobalConfig)
app.component("Home", Home)
app.component("FooterBar", FooterBar)
app.component("HospicePage", Hospice)
app.component("HospiceList", HospiceList)
app.component("NavigationBar", NavigationBar)
app.component("OrderConfirmation", OrderConfirmation)
app.component("OrderReview", OrderReview)
app.component("OrderCancel", OrderCancel)
// app.component("SiteAlert", SiteAlert)
app.component("TreeRegistration", TreeRegistration)
app.component("VolunteerRegistrationPage", VolunteerRegistrationView)
app.component("ContactPage", ContactView)
app.component("GridButton", Button)
// const store = createStore({
//   modules: {
//     ChristmasTreeStore,
//     ConfigStore,
//   },
// })

app.use(VueQueryPlugin)
app.use(pinia)
app.use(VueViewer)
app.mount("#app")
